<template>
  <div class="Contaus">
    <!-- banner start -->
    <div class="Cont-bannerbox">
      <div class="Cont-bannerbox-content">
        <p class="Contbox-contentname">联系我们</p>
        <p class="Contbannerbox-contenttext">
          Contact us
        </p>
      </div>
    </div>
    <div class="Cont-MapDz">
      <div class="Cont-MapDz-ron">
        <div class="Cont-MapDz-Dz">
          <div class="Cont-MapDz-Dz-ron">
            <div class="Cont-MapDz-Dz-tit">
              <p>即刻优势</p>
            </div>
            <div class="Cont-MapDz-Dz-log" @click="SelectHome()">
              <img src="../assets/Contachus-image/logo.png" />
            </div>
          </div>
          <div class="Cont-MapDz-Dz-tex">
            <p>
              深圳总部
            </p>
            <p>
              地址：深圳市福田区彩田路3002号小元里商务办公空间3楼
            </p>
            <p style="padding-bottom: 30px;">
              联系电话：待定
            </p>
            <p>
              上海分公司
            </p>
            <p>
              地址：上海市浦东新区长青路1200弄36号815-817室
            </p>
            <p style="padding-bottom: 30px;">
              联系电话：021-50770206
            </p>
            <p>E-mail：bd@nowyousee.cn</p>
          </div>
        </div>
        <div class="Cont-MapDz-Map">
          <img src="../assets/Contachus-image/Map.png" />
        </div>
      </div>
    </div>
    <div class="Cont-dwonBanner">
      <div class="Cont-dwonBanner-content">
        <p class="Cont-dwonBanner-contentname">让我们更了解您</p>
        <p class="Cont-dwonBanner-contenttext">
          KNOW
        </p>
      </div>
      <div class="Cont-dwonBanner-contenttextbox">
        <p class="Cont-dwonBanner-contenttexttwo">如果您有合作意向，请您填写下列表格在线申请或电话联系我们，我们将尽快给您回复，并为您提供最真诚的服务!</p>
      </div>
      <div class="Cont-dwonBanner-table">
        <div class="Cont-dwonBanner-table-top">
          <div class="Cont-dwonBanner-table-top-le">
            <el-input placeholder="您的名字" v-model="input" clearable></el-input>
          </div>
          <div class="Cont-dwonBanner-table-top-ri">
            <el-input placeholder="您的电话" v-model="input" clearable></el-input>
          </div>
        </div>
        <div class="Cont-dwonBanner-table-down">
          <el-input placeholder="您的邮箱" v-model="input" clearable></el-input>
        </div>
        <div class="Cont-dwonBanner-table-top">
          <div class="Cont-dwonBanner-table-top-le">
            <el-input placeholder="省/市" v-model="input" clearable></el-input>
          </div>
          <div class="Cont-dwonBanner-table-top-ri">
            <el-input placeholder="市/地区/详细地址" v-model="input" clearable></el-input>
          </div>
        </div>
        <div class="Cont-dwonBanner-table-textrea">
          <el-input type="textarea" :rows="8" placeholder="您的需求" v-model="textarea">
          </el-input>
        </div>
        <div class="Cont-dwonBanner-table-botton">
          <el-button type="primary">提交申请</el-button>
        </div>
      </div>
    </div>
    <!-- banner end -->
    <!-- 底部引入 -->
    <FooderContent></FooderContent>
  </div>
</template>

<script>
  import FooderContent from '../components/fooder.vue'
  export default {
    components: {
      FooderContent
    },
    methods: {
      /* 首页跳转 */
      SelectHome() {
        this.$router.push({
          path: '/Home'
        })
      },
    }
  }
</script>

<style>
  /* banner start */
  .Cont-bannerbox {
    width: 100%;
    min-width: 118rem;
    height: 43.75rem;
    background-image: url(../assets/Contachus-image/Contachustu.jpg);
    background-size: 100% 100%;
  }

  .Cont-bannerbox-content {
    width: 21.875rem;
    overflow: auto;
    padding-top: 13.5rem;
    padding-left: 55rem;
  }

  .Contbox-contentname {
    width: 37%;
    padding-bottom: 10px;
    font-size: 2rem;
    font-family: Source Han Sans SC;
    color: #FFFFFF;
    margin-bottom: 10px;
    border-bottom: 3px #16C816 solid;
  }

  .Contbannerbox-contenttext {
    width: 37%;
    font-size: 1.5rem;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
    opacity: 1;
    margin: 0;
  }

  /* banner stop */
  /* 地图开始 */
  .Cont-MapDz {
    width: 87.5rem;
    height: 34.125rem;
    background: #FFFFFF;
    box-shadow: 3px 10px 19px rgba(45, 45, 45, 0.16);
    border-radius: 10px 0px 0px 10px;
    margin: 0 auto;
    position: relative;
    bottom: 7rem;
  }

  .Cont-MapDz-ron {
    width: 95%;
    height: 34.125rem;
    margin: 0 auto;
  }

  .Cont-MapDz-Dz {
    width: 48%;
    height: 34.125rem;
    float: left;
  }

  .Cont-MapDz-Map {
    width: 48%;
    height: 34.125rem;
    float: right;
    overflow: hidden;
  }

  .Cont-MapDz-Map img {
    width: 100%;
    height: 34.125rem;
  }

  .Cont-MapDz-Map :hover {
    cursor: default;
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    -ms-transform: scale(1.1);
    -o-transform: scale(1.1);
    transform: scale(1.1);
    transition: all 0.4s linear;
  }

  .Cont-MapDz-Dz-ron {
    width: 100%;
    height: 7rem;
  }

  .Cont-MapDz-Dz-tit {
    width: 48%;
    height: 7rem;
    float: left;
  }

  .Cont-MapDz-Dz-tit p {
    font-size: 30px;
    margin: 36px 90px;
  }

  .Cont-MapDz-Dz-log {
    width: 48%;
    height: 7rem;
    float: right;

  }

  .Cont-MapDz-Dz-log img {
    margin: 34px 50px;

  }

  .Cont-MapDz-Dz-tex {
    width: 100%;
    height: 20.9375rem;
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    line-height: 29px;
    color: #333333;
    opacity: 1;
  }

  .Cont-MapDz-Dz-tex :hover {
    transform: translateY(-5px);
    transition: transform 0.4s;
  }

  .Cont-MapDz-Dz-tex p {
    margin-left: 10px;
  }

  /* 地图结束 */
  /* dwonBanner start */
  .Cont-dwonBanner {
    width: 100%;
    min-width: 118rem;
    height: 43.75rem;
    background-image: url(../assets/Contachus-image/Contchusdown.jpg);
    background-size: 100% 100%;
  }

  .Cont-dwonBanner-content {
    width: 21.875rem;
    overflow: auto;
    padding-top: 2.6875rem;
    padding-left: 55rem;
  }

  .Cont-dwonBanner-contentname {
    width: 56%;
    padding-bottom: 10px;
    font-size: 1.75rem;
    font-family: Source Han Sans SC;
    color: #FFFFFF;
    margin-bottom: 10px;
  }

  .Cont-dwonBanner-contenttext {
    width: 53%;
    font-size: 0.875rem;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
    opacity: 1;
    margin: 0;
    text-align: center;
    margin-bottom: 14px;
  }

  .Cont-dwonBanner-contenttexttwo {
    width: 37.75rem;
    height: 18px;
    font-size: 12px;
    font-family: SourceHanSansSC-Regular;
    line-height: 24px;
    color: #FFFFFF;
    opacity: 1;
  }

  .Cont-dwonBanner-contenttextbox {
    width: 29%;
    height: 18px;
    margin: 0 auto;
    margin-bottom: 1.5rem;
  }

  .Cont-dwonBanner-table {
    width: 80%;
    height: 30rem;
    margin: 0 auto;
  }

  .Cont-dwonBanner-table-top {
    width: 80%;
    height: 3.5rem;
    margin: 0 auto;
  }

  .Cont-dwonBanner-table-top-le {
    float: left;
    width: 48.5%;
  }

  .Cont-dwonBanner-table-top-le .el-input__inner {
    border-radius: 10px;
  }

  .Cont-dwonBanner-table-top-ri {
    float: right;
    width: 48.5%;
  }

  .Cont-dwonBanner-table-top-ri .el-input__inner {
    border-radius: 10px;
  }

  .Cont-dwonBanner-table-down {
    width: 80%;
    height: 3.5rem;
    margin: 0 auto;
  }

  .Cont-dwonBanner-table-down .el-input__inner {
    border-radius: 10px;
  }

  .Cont-dwonBanner-table-textrea {
    width: 80%;
    height: 12rem;
    margin: 0 auto;
  }

  .Cont-dwonBanner-table-textrea .el-textarea__inner {
    border-radius: 10px;
  }

  .Cont-dwonBanner-table-botton {
    width: 80%;
    height: 3.5rem;
    margin: 0 auto;
    margin-top: 24px;
  }

  .Cont-dwonBanner-table-botton .el-button {
    width: 100%;
    border-radius: 10px;
    background: #39AB6D;
    border-color: #39AB6D;
  }

  .Cont-dwonBanner-table-botton .el-button:focus,
  .el-button:hover {
    background: #39AB6D;
    border-color: #39AB6D;
  }

  /* dwonBanner stop */
  /* 媒体查询 小于100rem */
  @media screen and (max-width: 100rem) {

    /* bannet start */
    .Cont-bannerbox {
      width: 100%;
      min-width: 118rem;
      height: 43.75rem;
      background-image: url(../assets/Contachus-image/Contachustu.jpg);
      background-size: 100% 100%;
    }

    .Cont-bannerbox-content {
      width: 21.875rem;
      overflow: auto;
      padding-top: 13.5rem;
      padding-left: 55rem;
    }

    .Contbox-contentname {
      width: 37%;
      padding-bottom: 10px;
      font-size: 2rem;
      font-family: Source Han Sans SC;
      color: #FFFFFF;
      margin-bottom: 10px;
      border-bottom: 3px #16C816 solid;
    }

    .Contbannerbox-contenttext {
      width: 37%;
      font-size: 1.5rem;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #FFFFFF;
      opacity: 1;
      margin: 0;
    }

    /* bannet end */
    /* 地图开始 */
    .Cont-MapDz {
      width: 87.5rem;
      height: 34.125rem;
      background: #FFFFFF;
      box-shadow: 3px 10px 19px rgba(45, 45, 45, 0.16);
      border-radius: 10px 0px 0px 10px;
      margin: 0 auto;
      position: relative;
      bottom: 7rem;
      left: 12rem;
    }

    .Cont-MapDz-ron {
      width: 95%;
      height: 34.125rem;
      margin: 0 auto;
    }

    .Cont-MapDz-Dz {
      width: 48%;
      height: 34.125rem;
      float: left;
    }

    .Cont-MapDz-Map {
      width: 48%;
      height: 34.125rem;
      float: right;
    }

    .Cont-MapDz-Map img {
      width: 100%;
      height: 34.125rem;
    }

    .Cont-MapDz-Dz-ron {
      width: 100%;
      height: 7rem;
    }

    .Cont-MapDz-Dz-tit {
      width: 48%;
      height: 7rem;
      float: left;
    }

    .Cont-MapDz-Dz-tit p {
      font-size: 30px;
      margin: 36px 90px;
    }

    .Cont-MapDz-Dz-log {
      width: 48%;
      height: 7rem;
      float: right;
    }

    .Cont-MapDz-Dz-log img {
      margin: 34px 50px;
    }

    .Cont-MapDz-Dz-tex {
      width: 100%;
      height: 20.9375rem;
      font-size: 20px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      line-height: 29px;
      color: #333333;
      opacity: 1;
    }

    .Cont-MapDz-Dz-tex p {
      margin-left: 10px;
    }

    /* 地图结束 */
    /* dwonBanner start */
    .Cont-dwonBanner {
      width: 100%;
      min-width: 118rem;
      height: 43.75rem;
      background-image: url(../assets/Contachus-image/Contchusdown.jpg);
      background-size: 100% 100%;
    }

    .Cont-dwonBanner-content {
      width: 21.875rem;
      overflow: auto;
      padding-top: 2.6875rem;
      padding-left: 55rem;
    }

    .Cont-dwonBanner-contentname {
      width: 56%;
      padding-bottom: 10px;
      font-size: 1.75rem;
      font-family: Source Han Sans SC;
      color: #FFFFFF;
      margin-bottom: 10px;
    }

    .Cont-dwonBanner-contenttext {
      width: 53%;
      font-size: 0.875rem;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #FFFFFF;
      opacity: 1;
      margin: 0;
      text-align: center;
      margin-bottom: 14px;
    }

    .Cont-dwonBanner-contenttexttwo {
      width: 37.75rem;
      height: 18px;
      font-size: 12px;
      font-family: SourceHanSansSC-Regular;
      line-height: 24px;
      color: #FFFFFF;
      opacity: 1;
    }

    .Cont-dwonBanner-contenttextbox {
      width: 29%;
      height: 18px;
      margin: 0 auto;
      margin-bottom: 1.5rem;
    }

    .Cont-dwonBanner-table {
      width: 80%;
      height: 30rem;
      margin: 0 auto;
    }

    .Cont-dwonBanner-table-top {
      width: 80%;
      height: 3.5rem;
      margin: 0 auto;
    }

    .Cont-dwonBanner-table-top-le {
      float: left;
      width: 48.5%;
    }

    .Cont-dwonBanner-table-top-le .el-input__inner {
      border-radius: 10px;
    }

    .Cont-dwonBanner-table-top-ri {
      float: right;
      width: 48.5%;
    }

    .Cont-dwonBanner-table-top-ri .el-input__inner {
      border-radius: 10px;
    }

    .Cont-dwonBanner-table-down {
      width: 80%;
      height: 3.5rem;
      margin: 0 auto;
    }

    .Cont-dwonBanner-table-down .el-input__inner {
      border-radius: 10px;
    }

    .Cont-dwonBanner-table-textrea {
      width: 80%;
      height: 12rem;
      margin: 0 auto;
    }

    .Cont-dwonBanner-table-textrea .el-textarea__inner {
      border-radius: 10px;
    }

    .Cont-dwonBanner-table-botton {
      width: 80%;
      height: 3.5rem;
      margin: 0 auto;
      margin-top: 24px;
    }

    .Cont-dwonBanner-table-botton .el-button {
      width: 100%;
      border-radius: 10px;
      background: #39AB6D;
      border-color: #39AB6D;
    }

    .Cont-dwonBanner-table-botton .el-button:focus,
    .el-button:hover {
      background: #39AB6D;
      border-color: #39AB6D;
    }

    /* dwonBanner stop */
  }

  /* 媒体查询 小于62rem */
  @media screen and (max-width: 62rem) {

    /* bannet start */
    .Cont-bannerbox {
      width: 100%;
      min-width: 100%;
      height: 35.75rem;
      background-image: url(../assets/Contachus-image/Contachustu.jpg);
      background-size: 100% 100%;
    }

    .Cont-bannerbox-content {
      width: 21.875rem;
      overflow: auto;
      padding-top: 11.5rem;
      padding-left: 24rem;
    }

    .Contbox-contentname {
      width: 37%;
      padding-bottom: 10px;
      font-size: 2rem;
      font-family: Source Han Sans SC;
      color: #FFFFFF;
      margin-bottom: 10px;
      border-bottom: 3px #16C816 solid;
    }

    .Contbannerbox-contenttext {
      width: 37%;
      font-size: 1.5rem;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #FFFFFF;
      opacity: 1;
      margin: 0;
    }

    /* bannet end */
    /* 地图开始 */
    .Cont-MapDz {
      width: 100%;
      height: 57.125rem;
      background: #FFFFFF;
      box-shadow: 3px 10px 19px rgba(45, 45, 45, 0.16);
      border-radius: 10px 0px 0px 10px;
      margin: 0 auto;
      position: relative;
      bottom: 7rem;
      left: 0rem;
    }

    .Cont-MapDz-ron {
      width: 95%;
      height: 57.125rem;
      margin: 0 auto;
    }

    .Cont-MapDz-Dz {
      width: 100%;
      height: 27.125rem;
      float: left;
    }

    .Cont-MapDz-Map {
      width: 100%;
      height: 29.125rem;
      float: left;
    }

    .Cont-MapDz-Map img {
      width: 100%;
      height: 28.125rem;
    }

    .Cont-MapDz-Dz-ron {
      width: 100%;
      height: 7rem;
    }

    .Cont-MapDz-Dz-tit {
      width: 51%;
      height: 7rem;
      float: left;
    }

    .Cont-MapDz-Dz-tit p {
      font-size: 33px;
      margin: 32px 100px;
    }

    .Cont-MapDz-Dz-log {
      width: 48%;
      height: 7rem;
      float: right;
    }

    .Cont-MapDz-Dz-log img {
      margin: 34px 10px;
    }

    .Cont-MapDz-Dz-tex {
      width: 100%;
      height: 20.9375rem;
      font-size: 23px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      line-height: 29px;
      color: #333333;
      opacity: 1;
      text-align: center;
    }

    .Cont-MapDz-Dz-tex p {
      margin-left: 10px;
    }

    /* 地图结束 */
    /* dwonBanner start */
    .Cont-dwonBanner {
      width: 100%;
      min-width: 100%;
      height: 38.75rem;
      background-image: url(../assets/Contachus-image/Contchusdown.jpg);
      background-size: 100% 100%;
    }

    .Cont-dwonBanner-content {
      width: 21.875rem;
      width: 57%;
      overflow: auto;
      padding-top: 2.6875rem;
      padding-left: 21rem;
    }

    .Cont-dwonBanner-contentname {
      width: 50%;
      min-width: 49%;
      padding-bottom: 10px;
      font-size: 1.75rem;
      font-family: Source Han Sans SC;
      color: #FFFFFF;
      margin-bottom: 10px;
    }

    .Cont-dwonBanner-contenttext {
      width: 25%;
      min-width: 38%;
      font-size: 0.875rem;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #FFFFFF;
      opacity: 1;
      margin: 0;
      text-align: center;
      margin-bottom: 14px;
    }

    .Cont-dwonBanner-contenttexttwo {
      width: 38.75rem;
      height: 18px;
      font-size: 12px;
      font-family: SourceHanSansSC-Regular;
      line-height: 24px;
      color: #FFFFFF;
      opacity: 1;
    }

    .Cont-dwonBanner-contenttextbox {
      width: 66%;
      height: 18px;
      margin: 0 auto;
      margin-bottom: 1.5rem;
    }

    .Cont-dwonBanner-table {
      width: 80%;
      height: 30rem;
      margin: 0 auto;
    }

    .Cont-dwonBanner-table-top {
      width: 80%;
      height: 3.5rem;
      margin: 0 auto;
    }

    .Cont-dwonBanner-table-top-le {
      float: left;
      width: 48.5%;
    }

    .Cont-dwonBanner-table-top-le .el-input__inner {
      border-radius: 10px;
    }

    .Cont-dwonBanner-table-top-ri {
      float: right;
      width: 48.5%;
    }

    .Cont-dwonBanner-table-top-ri .el-input__inner {
      border-radius: 10px;
    }

    .Cont-dwonBanner-table-down {
      width: 80%;
      height: 3.5rem;
      margin: 0 auto;
    }

    .Cont-dwonBanner-table-down .el-input__inner {
      border-radius: 10px;
    }

    .Cont-dwonBanner-table-textrea {
      width: 80%;
      height: 12rem;
      margin: 0 auto;
    }

    .Cont-dwonBanner-table-textrea .el-textarea__inner {
      border-radius: 10px;
    }

    .Cont-dwonBanner-table-botton {
      width: 80%;
      height: 3.5rem;
      margin: 0 auto;
      margin-top: 24px;
    }

    .Cont-dwonBanner-table-botton .el-button {
      width: 100%;
      border-radius: 10px;
      background: #39AB6D;
      border-color: #39AB6D;
    }

    .Cont-dwonBanner-table-botton .el-button:focus,
    .el-button:hover {
      background: #39AB6D;
      border-color: #39AB6D;
    }

    /* dwonBanner stop */
  }

  /* 媒体查询 小于48rem */
  @media screen and (max-width: 48rem) {

    /* bannet start */
    .Cont-bannerbox {
      width: 100%;
      min-width: 100%;
      height: 24.75rem;
      background-image: url(../assets/Contachus-image/Contachustu.jpg);
      background-size: 100% 100%;
    }

    .Cont-bannerbox-content {
      width: 46%;
      overflow: auto;
      padding-top: 7.5rem !important;
      padding-left: 7rem !important;

    }

    .Contbox-contentname {
      width: 66%;
      padding-bottom: 10px;
      font-size: 1.5rem;
      font-family: Source Han Sans SC;
      color: #FFFFFF;
      margin-bottom: 10px;
      border-bottom: 3px #16C816 solid;
    }

    .Contbannerbox-contenttext {
      width: 62%;
      font-size: 1rem;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #FFFFFF;
      opacity: 1;
      margin: 0;
      text-align: center;
    }

    /* bannet end */
    /* 地图开始 */
    .Cont-MapDz {
      width: 100%;
      height: 44.125rem;
      background: #FFFFFF;
      box-shadow: 3px 10px 19px rgba(45, 45, 45, 0.16);
      border-radius: 10px 0px 0px 10px;
      margin: 0 auto;
      position: relative;
      bottom: 7rem;
      left: 0rem;
    }

    .Cont-MapDz-ron {
      width: 95%;
      height: 44.125rem;
      margin: 0 auto;
    }

    .Cont-MapDz-Dz {
      width: 100%;
      height: 27.125rem;
      float: left;
    }

    .Cont-MapDz-Map {
      width: 100%;
      height: auto;
      float: left;
    }

    .Cont-MapDz-Map img {
      width: 100%;
      height: auto;
    }

    .Cont-MapDz-Dz-ron {
      width: 100%;
      height: 7rem;
    }

    .Cont-MapDz-Dz-tit {
      width: 51%;
      height: 7rem;
      float: left;
      display: none;
    }

    .Cont-MapDz-Dz-tit p {
      font-size: 33px;
      margin: 33px 47px;
      display: none;
    }

    .Cont-MapDz-Dz-log {
      width: 100%;
      height: 7rem;
      float: right;
    }

    .Cont-MapDz-Dz-log img {
      margin: 32px 83px;
      width: 47%;
    }

    .Cont-MapDz-Dz-tex {
      width: 100%;
      height: 20.9375rem;
      font-size: 1rem;
      font-family: Source Han Sans SC;
      font-weight: 400;
      line-height: 29px;
      color: #333333;
      opacity: 1;
      text-align: center;
    }

    .Cont-MapDz-Dz-tex p {
      margin-left: 10px;
    }

    /* 地图结束 */
    /* dwonBanner start */
    .Cont-dwonBanner {
      width: 100%;
      min-width: 100%;
      height: 42.75rem;
      background-image: url(../assets/Contachus-image/Contchusdown.jpg);
      background-size: 100% 100%;
    }

    .Cont-dwonBanner-content {
      width: 57%;
      overflow: auto;
      padding-top: 2.6875rem;
      padding-left: 7rem;

    }

    .Cont-dwonBanner-contentname {
      width: 63%;
      min-width: 49%;
      padding-bottom: 10px;
      font-size: 1rem;
      font-family: Source Han Sans SC;
      color: #FFFFFF;
      margin-bottom: 10px;

    }

    .Cont-dwonBanner-contenttext {
      width: 59%;
      min-width: 38%;
      font-size: 0.875rem;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #FFFFFF;
      opacity: 1;
      margin: 0;
      text-align: center;
      margin-bottom: 14px;
    }

    .Cont-dwonBanner-contenttexttwo {
      width: 94%;
      height: 65px;
      font-size: 12px;
      font-family: SourceHanSansSC-Regular;
      line-height: 24px;
      color: #FFFFFF;
      opacity: 1;
      text-align: center;
      /* padding: 0px 5px; */
      margin: 0 auto;

    }

    .Cont-dwonBanner-contenttextbox {
      width: 100%;
      height: 65px;
      margin: 0 auto;
      margin-bottom: 1.5rem;
    }

    .Cont-dwonBanner-table {
      width: 100%;
      height: 30rem;
      margin: 0 auto;
    }

    .Cont-dwonBanner-table-top {
      width: 90%;
      height: 3.5rem;
      margin: 0 auto;
    }

    .Cont-dwonBanner-table-top-le {
      float: left;
      width: 48.5%;
    }

    .Cont-dwonBanner-table-top-le .el-input__inner {
      border-radius: 10px;
    }

    .Cont-dwonBanner-table-top-ri {
      float: right;
      width: 48.5%;
    }

    .Cont-dwonBanner-table-top-ri .el-input__inner {
      border-radius: 10px;
    }

    .Cont-dwonBanner-table-down {
      width: 90%;
      height: 3.5rem;
      margin: 0 auto;
    }

    .Cont-dwonBanner-table-down .el-input__inner {
      border-radius: 10px;
    }

    .Cont-dwonBanner-table-textrea {
      width: 90%;
      height: 12rem;
      margin: 0 auto;
    }

    .Cont-dwonBanner-table-textrea .el-textarea__inner {
      border-radius: 10px;
    }

    .Cont-dwonBanner-table-botton {
      width: 90%;
      height: 3.5rem;
      margin: 0 auto;
      margin-top: 24px;
    }

    .Cont-dwonBanner-table-botton .el-button {
      width: 100%;
      border-radius: 10px;
      background: #39AB6D;
      border-color: #39AB6D;
    }

    .Cont-dwonBanner-table-botton .el-button:focus,
    .el-button:hover {
      background: #39AB6D;
      border-color: #39AB6D;
    }

    /* dwonBanner stop */
  }
</style>



// WEBPACK FOOTER //
// src/views/Contactus.vue